import React, { useState, useContext, useCallback } from 'react'
import { Coupons as CPCoupons } from '@usap/widgets'
import { LocalContext } from '../../helpers/useLocalContext'
import { getPrivacyPolicy } from '../../helpers/getStaticData'
import { GTM } from '../../helpers'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'

export default function Coupons({
  history,
  apiDetails: { couponsData },
}) {
  const [message, setMessage] = useState('')

  const { localContext } = useContext(LocalContext)
  const { Link } = localContext
  const isWmoEnabled = useWmoEnabled()

  const onSubscribe = useCallback(formData => {
    const { blueshiftSubscribe } = GTM
    blueshiftSubscribe(formData)
    setTimeout(() => {
      if (isWmoEnabled) {
        window.location.href = '/offers-thankyou'
      } else {
        history.push('/coupons-thankyou')
      }
    }, 1000)
  }, [history, isWmoEnabled])

  if (!couponsData || !Object.keys(couponsData).length) return ''

  return (
    <CPCoupons
      onSubscribe={onSubscribe}
      message={message}
      setMessage={setMessage}
      Link={Link}
      getPrivacyPolicy={getPrivacyPolicy}
      couponsData={couponsData}
    />
  )
}
